export type Gender = 'male' | 'female' | 'other'
export type BloodGroup = 'A+' | 'A-' | 'B+' | 'B-' | 'AB+' | 'AB-' | 'O+' | 'O-'
export type StudentStatus = 'active' | 'inactive' | 'transferred' | 'graduated' | 'expelled'
export type GuardianRelation = 'father' | 'mother' | 'local_guardian' | 'other'

export const BLOOD_GROUPS: BloodGroup[] = ['A+', 'A-', 'B+', 'B-', 'AB+', 'AB-', 'O+', 'O-']
export const STUDENT_STATUSES: StudentStatus[] = [
  'active',
  'inactive',
  'transferred',
  'graduated',
  'expelled',
]
export const GUARDIAN_RELATIONS: GuardianRelation[] = ['father', 'mother', 'local_guardian', 'other']

export interface Enrollment {
  id: number
  academicYearId: number
  academicYear: string
  classId: number
  className: string
  sectionId: number
  sectionName: string
  rollNumber: string | null
  isCurrent: boolean
  status: 'enrolled' | 'promoted' | 'repeated' | 'withdrawn' | 'completed'
  enrolledAt: string
  endedAt: string | null
}

export interface StudentSummary {
  id: number
  studentCode: string
  admissionNumber: string
  firstName: string
  lastName: string
  fullName: string
  gender: Gender
  dateOfBirth: string | null
  status: StudentStatus
  phone: string | null
  photoUrl: string | null
  admissionDate: string
  currentEnrollment: Enrollment | null
  primaryGuardian: { name: string; phone: string | null; relation: GuardianRelation } | null
}

export interface Guardian {
  id: number
  relation: GuardianRelation
  name: string
  phone: string | null
  email: string | null
  occupation: string | null
  isPrimary: boolean
  hasPortalAccess: boolean
}

export interface StoredFile {
  id: number
  originalName: string
  mimeType: string
  size: number
  isPublic: boolean
  url: string | null
  downloadUrl: string
  createdAt: string
}

export interface StudentDetail {
  summary: StudentSummary
  bloodGroup: BloodGroup | null
  religion: string | null
  nationality: string | null
  email: string | null
  address: string | null
  medicalNotes: string | null
  guardians: Guardian[]
  enrollments: Enrollment[]
  documents: StoredFile[]
  account: { email: string; isActive: boolean } | null
  createdAt: string
  updatedAt: string
}

export interface StudentFilters {
  classId?: string
  sectionId?: string
  status?: string
  gender?: string
}
